import styled from 'styled-components';
import withResponsive from 'shared/helpers/withResponsive';
import breakpoints from '../../core/breakpoints';

export const Layout1 = withResponsive(styled.div`
	display: grid;
	grid-template-columns: 1fr;
	justify-items: center;
	align-items: center;
	@media (min-width: ${breakpoints.sm}) {
		grid-template-columns: 2fr 1fr;
		gap: 3rem;
	}
`);

export const Layout2 = withResponsive(styled.div`
	display: grid;
	gap: 1rem;
	grid-template-columns: 1fr;
	justify-items: center;
	align-items: center;
	@media (min-width: ${breakpoints.sm}) {
		grid-template-columns: 2fr 1fr 1fr;
	}
`);

export const Layout3 = withResponsive(styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 1rem;
	@media (min-width: ${breakpoints.sm}) {
		grid-template-columns: 1fr 1fr 1fr;
		gap: 3rem;
	}
`);

export const TextMargin = withResponsive(styled.div`
    @media (min-width: ${breakpoints.sm}) {
		margin-right: ${({ theme }) => theme.spacings[16]};
    `);

export const TextWidth = withResponsive(styled.div`
	@media (min-width: ${breakpoints.sm}) {
		width: 75%;
	}
`);
